import { render, staticRenderFns } from "./ListConvenio.vue?vue&type=template&id=460bf1b8&scoped=true"
import script from "./ListConvenio.vue?vue&type=script&lang=js"
export * from "./ListConvenio.vue?vue&type=script&lang=js"
import style0 from "./ListConvenio.vue?vue&type=style&index=0&id=460bf1b8&prod&lang=scss"
import style1 from "./ListConvenio.vue?vue&type=style&index=1&id=460bf1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bf1b8",
  null
  
)

export default component.exports